/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Settings for the clock in functionality
 * @export
 * @interface ClockingSettings
 */
export interface ClockingSettings {
    /**
     * 
     * @type {number}
     * @memberof ClockingSettings
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof ClockingSettings
     */
    earlyClockInPeriod: number | null;
    /**
     * 
     * @type {number}
     * @memberof ClockingSettings
     */
    clockInGracePeriod: number | null;
    /**
     * 
     * @type {number}
     * @memberof ClockingSettings
     */
    autoApprovalThresholdInMinutes: number;
    /**
     * 
     * @type {boolean}
     * @memberof ClockingSettings
     */
    employeesCanEditTimeEntries: boolean;
    /**
     * The number of hours after which an employee will be automatically clocked out.
     * @type {number}
     * @memberof ClockingSettings
     */
    autoClockOutDelayPeriod: number;
}

/**
 * Check if a given object implements the ClockingSettings interface.
 */
export function instanceOfClockingSettings(value: object): value is ClockingSettings {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('earlyClockInPeriod' in value) || value['earlyClockInPeriod'] === undefined) return false;
    if (!('clockInGracePeriod' in value) || value['clockInGracePeriod'] === undefined) return false;
    if (!('autoApprovalThresholdInMinutes' in value) || value['autoApprovalThresholdInMinutes'] === undefined) return false;
    if (!('employeesCanEditTimeEntries' in value) || value['employeesCanEditTimeEntries'] === undefined) return false;
    if (!('autoClockOutDelayPeriod' in value) || value['autoClockOutDelayPeriod'] === undefined) return false;
    return true;
}

export function ClockingSettingsFromJSON(json: any): ClockingSettings {
    return ClockingSettingsFromJSONTyped(json, false);
}

export function ClockingSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClockingSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'earlyClockInPeriod': json['earlyClockInPeriod'],
        'clockInGracePeriod': json['clockInGracePeriod'],
        'autoApprovalThresholdInMinutes': json['autoApprovalThresholdInMinutes'],
        'employeesCanEditTimeEntries': json['employeesCanEditTimeEntries'],
        'autoClockOutDelayPeriod': json['autoClockOutDelayPeriod'],
    };
}

  export function ClockingSettingsToJSON(json: any): ClockingSettings {
      return ClockingSettingsToJSONTyped(json, false);
  }

  export function ClockingSettingsToJSONTyped(value?: ClockingSettings | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'earlyClockInPeriod': value['earlyClockInPeriod'],
        'clockInGracePeriod': value['clockInGracePeriod'],
        'autoApprovalThresholdInMinutes': value['autoApprovalThresholdInMinutes'],
        'employeesCanEditTimeEntries': value['employeesCanEditTimeEntries'],
        'autoClockOutDelayPeriod': value['autoClockOutDelayPeriod'],
    };
}

